import { render, staticRenderFns } from "./OutpatientHistoricalCharges.vue?vue&type=template&id=cea892de&scoped=true"
import script from "./OutpatientHistoricalCharges.vue?vue&type=script&lang=js"
export * from "./OutpatientHistoricalCharges.vue?vue&type=script&lang=js"
import style0 from "./OutpatientHistoricalCharges.vue?vue&type=style&index=0&id=cea892de&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cea892de",
  null
  
)

export default component.exports